export const SITE_URL = "https://voktaa.com";
export const BRAND_NAME = "VOKTAA Solutions";
export const PRIMARY_ORG_ID = `${SITE_URL}/#organization`;

export const ORGANIZATION_SCHEMA = {
  "@context": "https://schema.org",
  "@type": ["EducationalOrganization", "LocalBusiness"],
  "@id": PRIMARY_ORG_ID,
  "name": BRAND_NAME,
  "legalName": "VOKTAA Solutions Training Academy",
  "url": SITE_URL,
  "logo": `${SITE_URL}/voktaa_icon.png`,
  "image": `${SITE_URL}/voktaa_icon.png`,
  "description": "VOKTAA Solutions provides industry-focused soft skills, spoken English, public speaking, and campus placement training across Andhra Pradesh. Empowering learners from classroom to career.",
  "founder": {
    "@type": "Person",
    "name": "P. Raja Sekhar"
  },
  "address": {
    "@type": "PostalAddress",
    "addressLocality": "Guntur",
    "addressRegion": "Andhra Pradesh",
    "addressCountry": "IN"
  },
  "contactPoint": {
    "@type": "ContactPoint",
    "telephone": "+91-7416113199",
    "contactType": "customer service",
    "email": "voktaasolutions@gmail.com",
    "areaServed": "IN",
    "availableLanguage": ["English", "Telugu"]
  },
  "sameAs": [
    "https://www.facebook.com/voktaasolutions",
    "https://www.linkedin.com/company/voktaa-solutions",
    "https://www.instagram.com/voktaasolutions"
  ]
};

export const WEBSITE_SCHEMA = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  "@id": `${SITE_URL}/#website`,
  "url": SITE_URL,
  "name": BRAND_NAME,
  "publisher": {
    "@id": PRIMARY_ORG_ID
  }
};

export const DEFAULT_SEO = {
  title: "VOKTAA Solutions | Soft Skills, Spoken English & Placement Training in AP",
  description: "VOKTAA Solutions provides industry-focused soft skills, spoken English, public speaking, and campus placement training across Andhra Pradesh. Empowering learners from classroom to career.",
  canonical: SITE_URL,
  ogImage: `${SITE_URL}/voktaa_icon.png`,
  ogType: "website",
  twitterCard: "summary_large_image"
};

export const PAGE_SEO = {
  home: {
    title: "VOKTAA Solutions | Soft Skills, Spoken English & Placement Training in AP",
    description: "VOKTAA Solutions provides industry-focused soft skills, spoken English, public speaking, and campus placement training across Andhra Pradesh. Empowering learners from classroom to career.",
    canonical: `${SITE_URL}/`,
    ogImage: `${SITE_URL}/voktaa_icon.png`,
    ogType: "website"
  },
  about: {
    title: "About VOKTAA Solutions | Founded by P. Raja Sekhar | Guntur, AP",
    description: "Learn about VOKTAA Solutions, founded by P. Raja Sekhar in Guntur, Andhra Pradesh. Discover our activity-based training methodology, mission, vision, and core team.",
    canonical: `${SITE_URL}/about`,
    ogImage: `${SITE_URL}/founder.png`,
    ogType: "article"
  },
  programs: {
    title: "Training Programmes & Syllabus | Soft Skills, Employability & TTT | VOKTAA",
    description: "Explore VOKTAA's training programmes: Campus to Cubicle employability, Soft Skills & Personality Development, Public Speaking, and Train-the-Trainer for educators.",
    canonical: `${SITE_URL}/programs`,
    ogImage: `${SITE_URL}/classroom_training.jpg`,
    ogType: "website"
  },
  institutions: {
    title: "Training for Engineering Colleges & Universities | VOKTAA Solutions",
    description: "Partner with VOKTAA Solutions for customized campus placement training, MOU partnerships, NAAC/NIRF accreditation support, and faculty development in Andhra Pradesh.",
    canonical: `${SITE_URL}/institutions`,
    ogImage: `${SITE_URL}/serve_institutions_clean.jpg`,
    ogType: "website"
  },
  reviews: {
    title: "Student & College Reviews | VOKTAA Solutions Success Stories",
    description: "Read real testimonials and reviews from students, engineering college management, and corporate clients trained by VOKTAA Solutions.",
    canonical: `${SITE_URL}/reviews`,
    ogImage: `${SITE_URL}/classroom_training.jpg`,
    ogType: "website"
  },
  contact: {
    title: "Contact VOKTAA Solutions | Book a Free Demo Class in Guntur, AP",
    description: "Get in touch with VOKTAA Solutions in Guntur, Andhra Pradesh. Call +91 74161 13199, email voktaasolutions@gmail.com, or book a free demo session today.",
    canonical: `${SITE_URL}/contact`,
    ogImage: `${SITE_URL}/voktaa_icon.png`,
    ogType: "website"
  }
};

export const PROGRAM_SLUG_SEO = {
  "campus-recruitment-training": {
    title: "Campus Recruitment Training (CRT) | VOKTAA Solutions",
    description: "Comprehensive placement preparation covering Group Discussions, Aptitude & Logical Reasoning, Resume Building, and Mock Technical & HR Interviews.",
    canonical: `${SITE_URL}/programs/campus-recruitment-training`,
    ogImage: `${SITE_URL}/serve_students_clean.jpg`,
    courseName: "Campus Recruitment Training (CRT)"
  },
  "soft-skills-development": {
    title: "Soft Skills Development Masterclass | VOKTAA Solutions",
    description: "Master interpersonal communication, emotional intelligence, teamwork, problem solving, time management, and professional workplace etiquette.",
    canonical: `${SITE_URL}/programs/soft-skills-development`,
    ogImage: `${SITE_URL}/classroom_training.jpg`,
    courseName: "Soft Skills Development"
  },
  "communication-business-skills": {
    title: "Communication & Business Skills Training | VOKTAA Solutions",
    description: "Master corporate vocabulary, business email & report writing, client pitching, presentation delivery, and workplace conversation.",
    canonical: `${SITE_URL}/programs/communication-business-skills`,
    ogImage: `${SITE_URL}/serve_corporate_clean.jpg`,
    courseName: "Communication & Business Skills"
  },
  "personality-development": {
    title: "Personality Development & Confidence Building | VOKTAA Solutions",
    description: "Enhance self-awareness, positive mindset, body language, social etiquette, emotional intelligence, and grooming for college students.",
    canonical: `${SITE_URL}/programs/personality-development`,
    ogImage: `${SITE_URL}/serve_students_clean.jpg`,
    courseName: "Personality Development"
  },
  "public-speaking-debate": {
    title: "Public Speaking & Debate Masterclass | VOKTAA Solutions",
    description: "Overcome stage fear, master voice modulation, speech structuring, storytelling, extempore speaking, and persuasive debate argumentation.",
    canonical: `${SITE_URL}/programs/public-speaking-debate`,
    ogImage: `${SITE_URL}/serve_institutions_clean.jpg`,
    courseName: "Public Speaking & Debate"
  },
  "interview-skills-mock-gds": {
    title: "Interview Skills & Mock GDs Training | VOKTAA Solutions",
    description: "Crack campus placements with mock interviews, common HR/technical questions, group discussion techniques, and salary negotiation skills.",
    canonical: `${SITE_URL}/programs/interview-skills-mock-gds`,
    ogImage: `${SITE_URL}/interview_mock_gd.jpg`,
    courseName: "Interview Skills & Mock GDs"
  },
  "career-guidance-programme": {
    title: "Career Guidance & Pathway Planning | VOKTAA Solutions",
    description: "Self-assessment, aptitude analysis, career path mapping, resume & portfolio development, industry awareness, and goal setting.",
    canonical: `${SITE_URL}/programs/career-guidance-programme`,
    ogImage: `${SITE_URL}/career_guidance.jpg`,
    courseName: "Career Guidance Programme"
  },
  "leadership-development": {
    title: "Leadership Development & Team Management | VOKTAA Solutions",
    description: "Develop leadership styles, critical thinking, delegation, decision making, conflict resolution, and strategic communication.",
    canonical: `${SITE_URL}/programs/leadership-development`,
    ogImage: `${SITE_URL}/leadership_development.jpg`,
    courseName: "Leadership Development"
  },
  "corporate-training-modules": {
    title: "Corporate Training Modules for Teams | VOKTAA Solutions",
    description: "Customized corporate workshops on workplace communication, professional etiquette, team collaboration, and time management.",
    canonical: `${SITE_URL}/programs/corporate-training-modules`,
    ogImage: `${SITE_URL}/serve_corporate_clean.jpg`,
    courseName: "Corporate Training Modules"
  },
  "company-specific-training": {
    title: "Company Specific Training Programmes | VOKTAA Solutions",
    description: "Tailored onboarding, role-specific communication standards, company process & SOP training, and domain simulations for corporate teams.",
    canonical: `${SITE_URL}/programs/company-specific-training`,
    ogImage: `${SITE_URL}/serve_corporate_clean.jpg`,
    courseName: "Company Specific Training"
  },
  "faculty-development-programmes": {
    title: "Faculty Development Programmes (FDP) | VOKTAA Solutions",
    description: "Empower college educators with modern teaching pedagogies, classroom engagement, outcome-based education (OBE), and communication skills.",
    canonical: `${SITE_URL}/programs/faculty-development-programmes`,
    ogImage: `${SITE_URL}/fdp_faculty_training.jpg`,
    courseName: "Faculty Development Programmes (FDP)"
  },
  "train-the-trainer-programme": {
    title: "Train-the-Trainer (TTT) Programme | VOKTAA Solutions",
    description: "Equip faculty members, educators, and trainers with interactive pedagogy, activity-based training design, and delivery methodologies.",
    canonical: `${SITE_URL}/programs/train-the-trainer-programme`,
    ogImage: `${SITE_URL}/classroom_training.jpg`,
    courseName: "Train-the-Trainer Programme"
  },
  "technical-skills": {
    title: "Technical Skills & Generative AI Masterclass | VOKTAA Solutions",
    description: "Practical training in Generative AI tools, Python programming, Data Analysis, Cloud Computing, Cybersecurity, and Web Development.",
    canonical: `${SITE_URL}/programs/technical-skills`,
    ogImage: `${SITE_URL}/serve_students_clean.jpg`,
    courseName: "Technical Skills"
  },
  // Legacy aliases mapped to canonical targets
  "campus-to-cubicle": {
    title: "Campus to Cubicle Employability Programme | VOKTAA Solutions",
    description: "Comprehensive placement preparation covering Group Discussions, mock interviews, corporate etiquette, aptitude, and resume building.",
    canonical: `${SITE_URL}/programs/campus-recruitment-training`,
    ogImage: `${SITE_URL}/serve_students_clean.jpg`,
    courseName: "Campus Recruitment Training (CRT)"
  },
  "soft-skills": {
    title: "Soft Skills & Personality Development Masterclass | VOKTAA Solutions",
    description: "Enhance interpersonal communication, emotional intelligence, body language, assertiveness, and professional workplace etiquette.",
    canonical: `${SITE_URL}/programs/soft-skills-development`,
    ogImage: `${SITE_URL}/classroom_training.jpg`,
    courseName: "Soft Skills Development"
  },
  "public-speaking": {
    title: "Public Speaking & Voice Modulation Masterclass | VOKTAA Solutions",
    description: "Master stage presence, speech delivery, voice modulation, fear elimination, and persuasive presentation skills.",
    canonical: `${SITE_URL}/programs/public-speaking-debate`,
    ogImage: `${SITE_URL}/serve_institutions_clean.jpg`,
    courseName: "Public Speaking & Debate"
  },
  "train-the-trainer": {
    title: "Train-the-Trainer (TTT) Programme for Educators | VOKTAA Solutions",
    description: "Equip faculty members, educators, and corporate trainers with modern interactive pedagogy and training design.",
    canonical: `${SITE_URL}/programs/train-the-trainer-programme`,
    ogImage: `${SITE_URL}/classroom_training.jpg`,
    courseName: "Train-the-Trainer Programme"
  },
  "interview-skills": {
    title: "Interview Skills & Mock GDs Training | VOKTAA Solutions",
    description: "Mock interviews, common-question preparation, and real-time feedback to remove hesitation under pressure.",
    canonical: `${SITE_URL}/programs/interview-skills-mock-gds`,
    ogImage: `${SITE_URL}/interview_mock_gd.jpg`,
    courseName: "Interview Skills & Mock GDs"
  }
};
